/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.AddToFavourites";
        class DocActionAddToFavourites extends DocActions.DocActionBaseClass {
            constructor(core, name) {
                super(core, name);
                this._currentDocId = null;
                this._currentDoc = null;
                this._modalSession = null;
                this._documentAdded = (response) => {
                    this._log.info("DocActionAddToFavourites._documentAdded()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(null, WPTNamespace.Navigation.LayoutActivationType.FAVOURITE_ADDED);
                    navEvent.ActivationID = this._currentDocId;
                    if (this._currentDoc)
                        navEvent.PrimaryContext = this._currentDoc;
                    navEvent.Layout = this._core.Navigation.Details.getActiveLayoutName();
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._currentDocId = null;
                    this._currentDoc = null;
                };
                this._failCallback = (json) => {
                    this._log.info("DocActionAddToFavourites._failCallback()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    let response = json;
                    console.warn(response.Connection.Message);
                    this._core.Helper.presentWarningModal(response.Connection.Message);
                    this._currentDocId = null;
                    this._currentDoc = null;
                };
                this._errorCallback = (url, status, message) => {
                    this._log.info("DocActionAddToFavourites._errorCallback()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    console.warn(message);
                    this._core.Helper.presentWarningModal(message);
                    this._currentDocId = null;
                    this._currentDoc = null;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionAddToFavourites::constructor");
                this._label = this._core.Locale.getTranslation("STR_WPT_ADD_FAVOURITE");
            }
            actionAllowed(request) {
                this._log.info("DocActionAddToFavourites.actionAllowed()");
                // May limit this based on overall config in SL, but can be globally switched off in GW anyway
                return this._core.serviceAvailable('favourites');
            }
            execute(request) {
                this._log.info("DocActionAddToFavourites.execute()");
                let modalSession = 'add-favourite-' + performance.now();
                if (this._log.isTraceEnabled()) {
                    this._log.trace("created modal session: " + modalSession);
                }
                if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                    this._modalSession = modalSession;
                }
                this._currentDocId = request.DocHandle;
                if (request.Document)
                    this._currentDoc = request.Document;
                this._core.Loader.genericServiceCall(`/User.svc/rest/InsertFavourite/${this._currentDocId}`, this._documentAdded, this._errorCallback, this._failCallback);
            }
        }
        DocActions.DocActionAddToFavourites = DocActionAddToFavourites;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
